import { render, staticRenderFns } from "./selected_results.vue?vue&type=template&id=0080174e&scoped=true&"
import script from "./selected_results.vue?vue&type=script&lang=js&"
export * from "./selected_results.vue?vue&type=script&lang=js&"
import style0 from "./selected_results.vue?vue&type=style&index=0&id=0080174e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080174e",
  null
  
)

export default component.exports